<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item
        prop="realName"
        label="姓名"
      >
        <el-input type="text" v-model="form.realName" placeholder="请填写姓名"></el-input>
      </el-form-item>
      <el-upload
        class="avatar-uploader"
        :action="appApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传头像</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="phone"
        label="联系方式"
      >
        <el-input type="text" v-model="form.phone" placeholder="请填写联系方式"></el-input>
      </el-form-item>
      <el-form-item
        prop="idcodeType"
        label="证件类型"
      >
        <el-select v-model="form.idcardType" clearable placeholder="请选择证件类型">
          <el-option
            v-for="item in cardTypesOptions"
            :key="item.dictItemCode"
            :label="item.dictItemName"
            :value="item.dictItemCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="idcodeCard"
        label="证件号"
      >
        <el-input type="text" v-model="form.idcardCode" placeholder="请填写证件号"></el-input>
      </el-form-item>
      <el-form-item
        prop="sex"
        label="性别"
      >
        <el-select v-model="form.sex" clearable placeholder="请选择性别">
          <el-option value="1" label="男"></el-option>
          <el-option value="0" label="女"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="remark"
        label="备注"
        class="ipt-textarea"
      >
        <el-input type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none"></el-input>
      </el-form-item>

      <div class="tc">
        <el-button
          style="width: 140px"
          type="primary"
         @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import {system, dict} from '../../api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {USER_ID} from '../../constants'

export default {
  name: 'UserEdit',
  created () {
    this.getUserInfo()
    this.getCards()
  },
  data () {
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      loading: false,
      submitting: false,
      cardTypes: 'IDCARD_TYPE',
      cardTypesOptions: [],
      imageUrl: '',
      form: {},
      rules: {
        realName: [
          {message: '请填写姓名', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        remark: [
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ],
        idcodeCard: [
          {message: '请填写证件号', trigger: 'blur'},
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ],
        phone: [
          {message: '请填写联系方式', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async getUserInfo () {
      this.loading = true
      let {data} = await system.getUserDetail(getSession(USER_ID))
      this.loading = false
      this.form = data
      this.imageUrl = process.env.VUE_APP_IMG + data.headImg
    },
    async getCards () {
      this.loading = true
      let {data} = await dict.getDictList({dictTypeCode: this.cardTypes})
      this.loading = false
      this.cardTypesOptions = data
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addUserInfo()
        } else {
          return false
        }
      })
    },
    async addUserInfo () {
      this.loading = true
      this.form.sysUserId = getSession(USER_ID)
      this.form.createUser = getSession(USER_ID)
      let {code} = await system.updateUser(this.form)
      if (code === 0) {
        this.$store.dispatch('user/setUserImg', this.form.headImg)
        this.$message({
          type: 'success',
          message: '修改个人信息成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '修改个人信息失败'
        })
      }
      this.loading = false
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.headImg = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let validImage1 = validImage(file, 500)
      this.loading = validImage1
      return validImage1
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 232px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 575px;
          }
        }
      }
      .el-upload,
      .el-upload--text {
        margin-left: 410px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
      .customizeCssArea {
        margin-left: 307px;
        margin-top: -58px;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
